import { render, staticRenderFns } from "./PageFoko.vue?vue&type=template&id=066ab662&"
import script from "./PageFoko.vue?vue&type=script&lang=js&"
export * from "./PageFoko.vue?vue&type=script&lang=js&"
import style0 from "./PageFoko.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports